import { IMenuTabConfig } from "../../../ui-partial/menu-bar/menu-bar.component";
import { LangService } from '../../../core/lang.service';
import { cloneDeep } from 'lodash';

export interface IView<T> extends IMenuTabConfig<T> {
  imgUrl: string,
  secondaryImgUrl?: string;
  description: string,
  hasIndicator?: boolean,
  disabled?: boolean;
}

export enum SchoolAdminView {
    DASHBOARD = 'dashboard',
    // DASHBOARD1 = 'dashboard1',
    TECH_READI = 'tech_readiness',
    TEACHERS = 'educators',
    STUDENTS = 'students',
    SESSIONS = 'sessions',
    REPORTS = 'reports',
    CLASSROOMS = 'classrooms',
    SCANNING = 'scanning',
  }

export enum BCFSASchoolAdminView {
  BC_FSA_TECH_READI = 'tech-readiness',
  BC_FSA_ASSESSMENTS = "assessment_setup1",
  BC_FSA_SESSION_INFO = 'bc_fsa_session_info',
  BC_FSA_ASSESSMENT_MATERIALS = 'assessment_materials',
  BC_FSA_STUDENTS = 'students',
  BC_FSA_SCHOOL_ADMINS = 'school_administrators',
  BC_FSA_FINAL_REPORT = "final_results",
  BC_FSA_COMPLETION_REPORTS = 'bc_fsa_completion_reports',
  BC_FSA_SCORE_ENTRY = 'score-entry',
  BC_FSA_SESSION_PROGRESS_REPORTS = 'session_reports',
  
}

export enum BCGradSchoolAdminView {
  BC_GRAD_TECH_READI = 'bc_grad_tech_readi',
  BC_GRAD_SCHOOL_ADMINS = 'school_administrators',
  // BC_GRAD_SESSION_INFO = 'bc_grad_session_info',
  BC_GRAD_ASSESSMENT_MATERIALS = 'assessment_materials',
  BC_GRAD_STUDENTS = 'bc_grad_students',
  BC_GRAD_COMPLETION_REPORTS = 'bc_grad_completion_reports',
  BC_GRAD_PRINTING = 'bc_grad_scanning/print',
  BC_GRAD_SCANNING = 'bc_grad_scanning',
  BC_GRAD_SCAN_UPLOAD = "bc_grad_scanning/scan_upload",
  BC_GRAD_DL_CENTER_REPORT = "bc_grad_dl_center_report"
}
  
export const SCHOOL_ADMIN_VIEWS = [
    {
      id:SchoolAdminView.TECH_READI, 
      caption: ('lbl_grad_tech_readi'), //'Technical Readiness',
      imgUrl: 'https://s3.ca-central-1.amazonaws.com/authoring.mathproficiencytest.ca/user_uploads/21/authoring/clipboard/1602235150476/clipboard.png',
      description: ('txt_tech_readi'), //'',
      hasIndicator: true,
    },
    {
      id:SchoolAdminView.CLASSROOMS, 
      caption: ('lbl_classes_groups'), //'Class Sections',
      imgUrl: 'https://s3.ca-central-1.amazonaws.com/authoring.mathproficiencytest.ca/user_uploads/21/authoring/school/1602128112754/school.png',
      description: ('txt_sa_classrooms_info_1'), //'You can review and manage the classes as they progress with their introductory materials and administration of the assessment.',
    },
    {
      id:SchoolAdminView.TEACHERS, 
      caption: ('lbl_teachers'), //'Teachers',
      imgUrl: 'https://s3.ca-central-1.amazonaws.com/authoring.mathproficiencytest.ca/user_uploads/21/authoring/work-from-home/1602128147290/work-from-home.png',
      description: ('txt_teachers'), // '0 accounts registered. Use this view to send email invitations to teachers so that they can access their account.',
    },
    {
      id:SchoolAdminView.STUDENTS, 
      caption: ('g9_students'), //'Students',
      imgUrl: 'https://s3.ca-central-1.amazonaws.com/authoring.mathproficiencytest.ca/user_uploads/21/authoring/students/1602128010278/students.png',
      description: ('txt_students') // '67 students are currently enrolled. Click here to validated their information and re-assign them to different teachers.',
    },
        
    {
      id:SchoolAdminView.SESSIONS, 
      caption: ('g9_sessions'), //'Assessment Sessions',
      imgUrl: 'https://s3.ca-central-1.amazonaws.com/authoring.mathproficiencytest.ca/user_uploads/21/authoring/calendar/1602128832706/calendar.png',
      description: ('txt_sessions') //'No assessment sessions have yet been scheduled. No assessments sessions have been run. Teachers can schedule assessments from their dashboard.',
    },
    {
      id:SchoolAdminView.REPORTS, 
      caption: ('lbl_reports'), //'Assessment Sessions',
      imgUrl: 'https://s3.ca-central-1.amazonaws.com/authoring.mathproficiencytest.ca/user_uploads/21/authoring/report/1614338286078/report.png',
      description: ('txt_reports_description') //'No assessment sessions have yet been scheduled. No assessments sessions have been run. Teachers can schedule assessments from their dashboard.',
    },
]


export const BC_FSA_SCHOOL_ADMIN_VIEWS = [
  {
    id:BCFSASchoolAdminView.BC_FSA_TECH_READI, 
    caption: ('sa_tech_readiness_bc'), //'Technical Readiness',
    imgUrl: 'https://d3azfb2wuqle4e.cloudfront.net/user_uploads/515714/authoring/Group_15__1_/1680274647527/Group_15__1_.png',
    description: ("sa_tech_readiness_desc_bc"),
    disabled: false,
  },
  {
    id: BCFSASchoolAdminView.BC_FSA_ASSESSMENT_MATERIALS,
    caption: ('sa_assessment_material_bc'), //'Assessment Materials',
    imgUrl: 'https://s3.ca-central-1.amazonaws.com/authoring.mathproficiencytest.ca/user_uploads/6388/authoring/assessment_materials/1610134259593/assessment_materials.svg',
    description: ('sa_assessment_material_desc_bc'),
    disabled: false,
  },
  {
    id: BCFSASchoolAdminView.BC_FSA_SCHOOL_ADMINS,
    caption: ('sa_admin_accounts_bc'), //'Administrator Accounts',
    imgUrl: 'https://d3azfb2wuqle4e.cloudfront.net/user_uploads/515714/authoring/Group_15/1680274705544/Group_15.png',
    description: ('sa_admin_accounts_desc_bc'),
    disabled: false,
  },
  {
    id: BCFSASchoolAdminView.BC_FSA_STUDENTS,
    caption: ('sa_students_bc'), //'Students',
    imgUrl: 'https://s3.ca-central-1.amazonaws.com/authoring.mathproficiencytest.ca/user_uploads/6388/authoring/student_info/1610134278044/student_info.svg',
    description: ('sa_students_desc_bc'),
    disabled: false,
  },
  {
    id: BCFSASchoolAdminView.BC_FSA_SESSION_PROGRESS_REPORTS,
    caption: ('sa_session_reports_bc'), //'Session Reports',
    imgUrl: 'https://s3.ca-central-1.amazonaws.com/authoring.mathproficiencytest.ca/user_uploads/6388/authoring/session_progress_reports/1610134294563/session_progress_reports.svg',
    description: ('sa_session_reports_desc_bc'),
    disabled: false,
  },
  {
    id: BCFSASchoolAdminView.BC_FSA_SCORE_ENTRY,
    caption: ('sa_score_entry_bc'), //'Session Entry',
    imgUrl: 'https://s3.ca-central-1.amazonaws.com/authoring.mathproficiencytest.ca/user_uploads/515714/authoring/customer/1660322306834/customer.png',
    description: ('sa_score_entry_desc_bc'), // '0 accounts registered. Use this view to send email invitations to teachers so that they can access their account.',
    disabled: false,
  },
  {
    id: BCFSASchoolAdminView.BC_FSA_FINAL_REPORT,
    caption: ('sa_results_reports_bc'), //'Final Results',
    imgUrl: 'https://s3.ca-central-1.amazonaws.com/authoring.mathproficiencytest.ca/user_uploads/6388/authoring/final_results/1610134339358/final_results.svg',
    description: ('sa_results_reports_desc_bc'), // '0 accounts registered. Use this view to send email invitations to teachers so that they can access their account.',
    disabled: false,
  }
]

export const BC_FSA_SCHOOL_ADMIN_SCORE_ENTRY_VIEWS = [
  {
    id: BCFSASchoolAdminView.BC_FSA_STUDENTS,
    caption: ('sa_students_bc'), //'Students',
    imgUrl: 'https://s3.ca-central-1.amazonaws.com/authoring.mathproficiencytest.ca/user_uploads/6388/authoring/student_info/1610134278044/student_info.svg',
    description: ('sa_students_desc_bc'),
    disabled: true,
  },
  {
    id: BCFSASchoolAdminView.BC_FSA_SCORE_ENTRY,
    caption: ('sa_score_entry_bc'), //'Session Entry',
    imgUrl: 'https://s3.ca-central-1.amazonaws.com/authoring.mathproficiencytest.ca/user_uploads/515714/authoring/customer/1660322306834/customer.png',
    description: ('sa_score_entry_desc_bc'), // '0 accounts registered. Use this view to send email invitations to teachers so that they can access their account.',
    disabled: true,
  },
  {
    id: BCFSASchoolAdminView.BC_FSA_FINAL_REPORT,
    caption: ('sa_results_reports_bc'), //'Final Results',
    imgUrl: 'https://s3.ca-central-1.amazonaws.com/authoring.mathproficiencytest.ca/user_uploads/6388/authoring/final_results/1610134339358/final_results.svg',
    description: ('sa_results_reports_desc_bc'), // '0 accounts registered. Use this view to send email invitations to teachers so that they can access their account.',
    disabled: true,
  }
]

// export const BC_FSA_SCHOOL_ADMIN_SCORE_ENTRY_VIEWS = cloneDeep(BC_FSA_SCHOOL_ADMIN_VIEWS);

export const BC_GRAD_SCHOOL_ADMIN_VIEWS = [
  {
    id:BCGradSchoolAdminView.BC_GRAD_TECH_READI, 
    caption: ('lbl_grad_tech_readi'), //'Technical Readiness',
    imgUrl: 'https://s3.ca-central-1.amazonaws.com/authoring.mathproficiencytest.ca/user_uploads/6526/authoring/Technical Readiness/1606258416870/Technical Readiness.png',
    description: ('sa_grad_teach_readiness_desc'), //'',
    disabled: false
  },
  {
    id:BCGradSchoolAdminView.BC_GRAD_ASSESSMENT_MATERIALS, 
    caption: ('sa_assessment_material_bc'), //'Technical Readiness',
    imgUrl: 'https://s3.ca-central-1.amazonaws.com/authoring.mathproficiencytest.ca/user_uploads/6526/authoring/Session Information/1606258514776/Session Information.png',
    description: ('sa_grad_assessment_materials_desc'), //'',
    disabled: false
  },
  {
    id: BCGradSchoolAdminView.BC_GRAD_SCHOOL_ADMINS,
    caption: ('sa_admin_accounts_bc'), //'Administrator Accounts',
    imgUrl: 'https://s3.ca-central-1.amazonaws.com/authoring.mathproficiencytest.ca/user_uploads/515770/authoring/Group_15/1631743213180/Group_15.png',
    description: ('sa_admin_accounts_desc_bc'),
    disabled: false,
  },
  {
    id:BCGradSchoolAdminView.BC_GRAD_STUDENTS, 
    caption: ('sa_grad_student_registration_title'), //'Students',
    imgUrl: 'https://s3.ca-central-1.amazonaws.com/authoring.mathproficiencytest.ca/user_uploads/6388/authoring/student_info/1610134278044/student_info.svg',
    description: ('sa_grad_student_registration_desc'), //
    disabled: false
  },
  {
    id:BCGradSchoolAdminView.BC_GRAD_PRINTING, 
    caption: ('sa_grad_print_response_sheet_title'), //'Students',
    imgUrl: 'https://s3.ca-central-1.amazonaws.com/authoring.mathproficiencytest.ca/user_uploads/515770/authoring/printing/1631739487692/printing.png',
    description: ('sa_grad_print_response_sheet_desc'), // '67 students are currently enrolled. Click here to validated their information and re-assign them to different teachers.',
    disabled: false,
  },
  {
    id:BCGradSchoolAdminView.BC_GRAD_COMPLETION_REPORTS, 
    caption: ('sa_grad_completion_report_title'), //'Technical Readiness',
    imgUrl: 'https://s3.ca-central-1.amazonaws.com/authoring.mathproficiencytest.ca/user_uploads/6526/authoring/Completion Reports/1606258648133/Completion Reports.png',
    description: ('sa_grad_completion_report_desc'), //'',
    disabled: false,
  },
  {
    id:BCGradSchoolAdminView.BC_GRAD_SCAN_UPLOAD, 
    caption: ('sa_grad_scan_response_sheets_title'), //'Students',
    imgUrl: 'https://s3.ca-central-1.amazonaws.com/authoring.mathproficiencytest.ca/user_uploads/6526/authoring/Scanning/1606258703307/Scanning.png',
    description: ('sa_grad_scan_response_sheets_desc'), // '67 students are currently enrolled. Click here to validated their information and re-assign them to different teachers.',
    disabled: false,
  },
  {
    id:BCGradSchoolAdminView.BC_GRAD_DL_CENTER_REPORT, 
    caption: ('dl_dashboard_title'), //'Students',
    imgUrl: 'https://s3.ca-central-1.amazonaws.com/authoring.mathproficiencytest.ca/user_uploads/515714/authoring/Group 3/1642101887733/Group 3.svg',
    description: ('dl_dashboard_desc'), // '67 students are currently enrolled. Click here to validated their information and re-assign them to different teachers.',
    isHidden: true,
    disabled: false,
  },
]
